import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import 'react-html5-camera-photo/build/css/index.css';
import back from "../../assets/Icons/Back-white.png"
import demoIcon from "../../assets/Icons/image-reference.png"
import teethListIcon from "../../assets/Icons/teeth-list-icon.png"
import flashOn from "../../assets/Icons/flash-on.png"
import flashOff from "../../assets/Icons/flash-off.png"
import DemoScreens from './demoScreens';
import Preview from './preview';
import "./index.css"
import { generateSteps } from "./steps";
import PermissionPopup from './cameraPermissionPopup';
import { GetBrowserDetails } from '../../Utils/deviceDetails';
import { GetMobileOperatingSystem } from '../../Utils/getOS';
import { fontStyle, fontWeight, companyBucket } from "../../Utils/tpscanStyle"
import FrontCameraError from './frontCameraError';
import { postLogDetails } from '../../Services/APIs/appDetails';
import teethSides from '../../Utils/teethSideNames';
import { notifyCameraError } from '../../Services/APIs/scan';
import { getCompleteDeviceDetails } from '../../Utils/comepleteDeviceInfo';
import Overlapper from '../StarInsurance/Scan/overlapper';
import PreviewFace from '../StarInsurance/Scan/previewFace';

const Shoot = (props) => {
    const { activeImageSide, setToothPicker, quickScan, setImageSide } = props;
    const navigate = useNavigate();
    const OS = GetMobileOperatingSystem();
    const uid = JSON.parse(localStorage.getItem("usertpi") || '{}').usertpi;
    const app = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket;

    // Get stored camera preference
    const storedCameraSide = localStorage.getItem("cameraSide") || "front";
    const [cameraSide, setCameraSide] = useState(storedCameraSide);
    const steps = generateSteps(cameraSide);

    // Initialize camera state
    const [facialMode, setFacialMode] = useState(
        storedCameraSide === "back" ? FACING_MODES.ENVIRONMENT : FACING_MODES.USER
    );
    const [frontCameraError, setFrontCameraError] = useState(false);
    const [backCameraError, setBackCameraError] = useState(false);
    const [isDemo, setDemo] = useState(true);
    const [isCamera, setCamera] = useState(true);
    const [capturedImage, setCapturedImage] = useState();
    const [flashLight, setFlashLight] = useState(false);
    const [mediaStream, setStream] = useState(null);
    const [errorType, setErrorType] = useState({ isError: false, type: "ios" });
    const [cameraInitialized, setCameraInitialized] = useState(false);
    const [isMirrored, setIsMirrored] = useState(storedCameraSide !== "back"); // Mirror front camera by default
    const initializedRef = useRef(false); // Ref to track initialization across renders

    // Log camera operation
    const logCameraOperation = (message) => {
        postLogDetails({
            uid,
            app,
            payLoad: message
        });
    };

    // Handle camera errors
    const handleCameraError = (error) => {
        logCameraOperation(`Camera error: ${JSON.stringify(error)}`);
        notifyCameraError({
            info: {
                ...getCompleteDeviceDetails(),
                uid,
                app,
                error: JSON.stringify(error)
            }
        });
    };

    // Clean up when component unmounts
    // useEffect(() => {
    //     return () => {
    //         if (mediaStream && flashLight) {
    //             setFlashLight(false);
    //         }
    //         console.log("called line 82 coponent did unmount")
    //         stopCamera();
    //     };
    // }, [mediaStream]);

    // iOS front camera handler
    const handleWithFacialMode = () => {
        if (storedCameraSide === "back") {
            // Explicitly try to use back camera for iOS
            navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: FACING_MODES.ENVIRONMENT,
                    width: { ideal: window.innerWidth },
                    height: { ideal: window.innerHeight }
                }
            })
                .then((stream) => {
                    setFacialMode(FACING_MODES.ENVIRONMENT);
                    setStream(stream);
                    setCameraInitialized(true);
                    logCameraOperation(`iOS - successfully initialized back camera`);
                })
                .catch((error) => {
                    handleCameraError(error);
                    setBackCameraError(true);
                    setFacialMode(FACING_MODES.USER);
                    logCameraOperation(`iOS - back camera failed, falling back to front camera`);
                });
        } else {
            navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: FACING_MODES.USER,
                    width: { ideal: window.innerWidth },
                    height: { ideal: window.innerHeight }
                }
            })
                .then((stream) => {
                    setFacialMode(FACING_MODES.USER);
                    setStream(stream);
                    setCameraInitialized(true);
                    logCameraOperation(`iOS - found front camera, video-track-length-${stream.getVideoTracks().length}`);
                })
                .catch((error) => {
                    handleCameraError(error);
                    setFrontCameraError(true);
                    setFacialMode(FACING_MODES.ENVIRONMENT);
                    logCameraOperation(`iOS - front camera error, falling back to rear-camera`);
                });
        }
    };

    // Android camera handler - uses device enumeration
    const handleWithLabel = () => {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const videoDevices = devices.filter(device => device.kind === 'videoinput');
                logCameraOperation(`Found ${videoDevices.length} video devices: ${JSON.stringify(videoDevices.map(d => d.label))}`);

                if (storedCameraSide === "back") {
                    // Try to find back camera by common naming patterns
                    const backCamera = videoDevices.find(device => {
                        const label = device.label.toLowerCase();
                        return label.includes('back') ||
                            label.includes('rear') ||
                            label.includes('environment') ||
                            // Some devices have numbered cameras where 0 is back
                            (label.includes('camera 0') && videoDevices.length > 1);
                    });

                    if (backCamera) {
                        // Use device ID for more reliable camera selection
                        logCameraOperation(`Android - found back camera: ${backCamera.label}`);
                        navigator.mediaDevices.getUserMedia({
                            video: {
                                deviceId: { exact: backCamera.deviceId },
                                width: { ideal: window.innerWidth },
                                height: { ideal: window.innerHeight }
                            }
                        })
                            .then(stream => {
                                setStream(stream);
                                setCameraInitialized(true);
                                setFacialMode({ exact: backCamera.deviceId });
                                logCameraOperation(`Android - successfully initialized back camera`);
                            })
                            .catch(error => {
                                handleCameraError(error);
                                setBackCameraError(true);
                                // Fallback to environment mode
                                setFacialMode(FACING_MODES.ENVIRONMENT);
                                logCameraOperation(`Android - back camera deviceId failed, falling back to ENVIRONMENT mode`);
                            });
                    } else {
                        // If no back camera found by label, use environment mode
                        logCameraOperation(`Android - no back camera found by label, using ENVIRONMENT mode`);
                        setFacialMode(FACING_MODES.ENVIRONMENT);
                    }
                } else {
                    // // For front camera
                    // const frontCamera = videoDevices.find(device => {
                    //     const label = device.label.toLowerCase();
                    //     return label.includes('front') ||
                    //         label.includes('user') ||
                    //         label.includes('selfie') ||
                    //         // Some devices have numbered cameras where 1 is front (when multiple cameras exist)
                    //         (label.includes('camera 1') && videoDevices.length > 1);
                    // });

                    // if (frontCamera) {
                    //     logCameraOperation(`Android - found front camera: ${frontCamera.label}`);
                    //     navigator.mediaDevices.getUserMedia({
                    //         video: {
                    //             deviceId: { exact: frontCamera.deviceId },
                    //             width: { ideal: window.innerWidth },
                    //             height: { ideal: window.innerHeight }
                    //         }
                    //     })
                    //         .then(stream => {
                    //             setStream(stream);
                    //             setCameraInitialized(true);
                    //             setFacialMode({ exact: frontCamera.deviceId });
                    //             logCameraOperation(`Android - successfully initialized front camera`);
                    //         })
                    //         .catch(error => {
                    //             handleCameraError(error);
                    //             setFrontCameraError(true);
                    //             // Fallback to user mode
                    //             setFacialMode(FACING_MODES.USER);
                    //             logCameraOperation(`Android - front camera deviceId failed, falling back to USER mode`);
                    //         });
                    // } else {
                    //     // If no front camera found by label, use user mode
                    //     logCameraOperation(`Android - no front camera found by label, using USER mode`);
                    //     setFacialMode(FACING_MODES.USER);
                    // }
                    navigator.mediaDevices.enumerateDevices()
                        .then(devices => {
                            const videoDevices = devices.filter(device => device.kind === 'videoinput');
                            const frontCamera = videoDevices.find(device => device.getCapabilities().facingMode?.includes("user"));
                            if (frontCamera) {
                                setFacialMode(frontCamera.deviceId); // Set the deviceId directly
                                postLogDetails({ uid, app, payLoad: "Android - found front camera" })

                            } else {
                                postLogDetails({ uid, app, payLoad: `Android- front camera error  ${JSON.stringify(videoDevices)} so starting rear-camera` })
                                notifyCameraError({ info: { ...getCompleteDeviceDetails(), uid, app, error: JSON.stringify(videoDevices) } })
                                setFacialMode(FACING_MODES.ENVIRONMENT); // Fallback to rear camera
                                setFrontCameraError(true)
                            }
                        })
                        .catch(err => {
                            postLogDetails({ uid, app, payLoad: `Android- media devices error ${JSON.stringify(err)}` })
                        });
                }
            })
            .catch(err => {
                logCameraOperation(`Android - media devices enumeration error ${JSON.stringify(err)}`);
                // Default fallback based on stored preference
                setFacialMode(storedCameraSide === "back" ? FACING_MODES.ENVIRONMENT : FACING_MODES.USER);
            });
    };

    // Handle camera type selection based on OS
    const handleCameraType = () => {
        // Don't reinitialize camera if we've already set it up
        if (initializedRef.current) {
            logCameraOperation(`Camera already initialized, skipping handleCameraType`);
            return;
        }

        // Mark as initialized using the ref
        initializedRef.current = true;

        if (storedCameraSide === "back") {
            logCameraOperation(`Explicitly initializing BACK camera`);
            // Direct approach for back camera
            navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: { exact: "environment" },
                    width: { ideal: window.innerWidth },
                    height: { ideal: window.innerHeight }
                }
            })
                .then(stream => {
                    setStream(stream);
                    setFacialMode(FACING_MODES.ENVIRONMENT);
                    setCameraInitialized(true);
                    logCameraOperation(`Back camera initialized successfully`);
                })
                .catch(err => {
                    logCameraOperation(`Failed to initialize back camera: ${JSON.stringify(err)}`);
                    initializedRef.current = false; // Reset so we can try again
                    OS === "iOS" ? handleWithFacialMode() : handleWithLabel();
                });
        } else {
            OS === "iOS" ? handleWithFacialMode() : handleWithLabel();
        }
    };

    const cameraStarted = (stream) => {
        setStream(stream);
        handleCameraType();
        setErrorType({ isError: false, type: "ios" });
    };

    // Stop camera
    const stopCamera = () => {
        if (mediaStream) {
            mediaStream.getTracks().forEach((track) => {
                logCameraOperation(`Stopping track with kind: ${track.kind}, readyState: ${track.readyState}`);
                track.stop();
                logCameraOperation(`Track stopped ${track.kind}, readyState: ${track.readyState}`);
            });
            setStream(null);
        }
    };

    // Restart camera
    const restartCamera = () => {
        // For deviceId mode
        if (typeof facialMode === 'object' && facialMode.exact) {
            navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: facialMode,
                    width: { ideal: window.innerWidth },
                    height: { ideal: window.innerHeight }
                }
            })
                .then((stream) => {
                    setStream(stream);
                    logCameraOperation(`Restarted Streaming with deviceId`);
                })
                .catch((err) => {
                    logCameraOperation(`Stream error with deviceId ${JSON.stringify(err)}`);
                    // Fallback to facing mode
                    setFacialMode(storedCameraSide === "back" ? FACING_MODES.ENVIRONMENT : FACING_MODES.USER);
                });
        } else {
            // For facing mode
            navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: facialMode,
                    width: { ideal: window.innerWidth },
                    height: { ideal: window.innerHeight }
                }
            })
                .then((stream) => {
                    setStream(stream);
                    logCameraOperation(`Restarted Streaming with facingMode`);
                })
                .catch((err) => {
                    logCameraOperation(`Stream error with facingMode ${JSON.stringify(err)}`);
                });
        }
    };

    // Handle photo capture
    const handleTakePhoto = (dataUri) => {
        console.log("called 339 handle take photo")
        const base64String = dataUri.split(',')[1]; // Remove the data URI scheme part
        const base64StringLength = base64String.length;
        const estimatedSizeInBytes = (base64StringLength * 3) / 4; // Base64 size formula
        const estimatedSizeInKB = estimatedSizeInBytes / 1024; // Convert to KB
        const estimatedSizeInMB = estimatedSizeInKB / 1024; // Convert to MB

        setCapturedImage(dataUri);
        logCameraOperation(`captured ${teethSides[activeImageSide]} teeth, ${estimatedSizeInMB.toFixed(5)} MB`);

        setTimeout(() => {
            setCamera(false);
        }, 400);

        stopCamera();
        // setTimeout(() => restartCamera(), 500);
    };

    // Check for camera permission errors
    const checkError = () => {
        const browser = GetBrowserDetails();

        if (browser.name === "Mobile Chrome") {
            navigator.permissions.query({ name: 'camera' }).then((res) => {
                if (res.state === "denied") {
                    if (OS === 'iOS') {
                        setErrorType({ isError: true, type: "ios" });
                    } else {
                        setErrorType({ isError: true, type: "android" });
                    }
                }
            }).catch((error) => {
                setErrorType({ isError: true, type: "ios" });
            });
        } else {
            setErrorType({ isError: true, type: "ios" });
        }
    };

    // Ovule shape component
    const OvuleShape = () => {
        return (
            <div className={`ovule-container w-full flex flex-col justify-center items-center `}>
                <div
                    className={`relative ovule ovule-${activeImageSide} ${activeImageSide === 4 &&
                        isCamera &&
                        cameraSide !== "back" &&
                        "ovule-4-reversed"
                        }`}
                >
                    <p
                        className={`absolute -bottom-10 w-full text-center text-base text-white ${activeImageSide === 4 && isCamera && cameraSide !== "back" && "transform rotate-180"} `}
                        style={(companyBucket == "done" || companyBucket === "hascompanies") ? { fontWeight: 400, ...fontStyle } : { ...fontWeight, ...fontStyle }}>
                        {steps[activeImageSide].title}
                    </p>
                </div>
            </div>
        );
    };

    // Top layer component
    const TopLayer = () => {
        return (
            <div className='camera-top-layer-2 h-full absolute top-0 text-white w-full'>
                <div className='flex justify-between items-center h-13 px-2'>
                    <button type='button' onClick={() => { localStorage.getItem("isAutomated") ? window.history.back() : setToothPicker(true) }}>
                        <img src={back} alt="back" className="w-8 h-8" />
                    </button>
                    <div className='pt-2 flex items-center'>
                        {/* Mirror toggle button for front camera */}
                        {/* {isCamera && storedCameraSide !== "back" && (
                            <button
                                type='button'
                                onClick={() => setIsMirrored(!isMirrored)}
                                className="w-12 h-12 mx-2 flex items-center justify-center bg-black bg-opacity-50 rounded-full"
                            >
                                <span className="text-lg">
                                    {isMirrored ? "⟷" : "↔"}
                                </span>
                            </button>
                        )} */}
                        <button type='button' onClick={() => { setDemo(true) }}>
                            <img src={demoIcon} alt="back" className="w-12 h-12" />
                        </button>
                    </div>
                </div>
                <p
                    className={`text-base mt-16 text-center ${activeImageSide === 4 && isCamera && cameraSide !== "back" && "transform rotate-180"}`}
                    style={(companyBucket == "done" || companyBucket === "hascompanies") ? { fontWeight: 400, ...fontStyle } : { ...fontWeight, ...fontStyle }}>
                    {isCamera ? "Tap anywhere to capture" : `Preview of the ${steps[activeImageSide].title}`}
                </p>
            </div>
        );
    };

    // Display back camera error message
    const BackCameraError = ({ back }) => {
        return (
            <div className="absolute top-0 w-full bg-black bg-opacity-80 p-4 text-white">
                <p>Back camera could not be activated. Using front camera instead.</p>
                <button
                    className="mt-2 px-4 py-2 bg-blue-500 rounded"
                    onClick={() => back(false)}
                >
                    Dismiss
                </button>
            </div>
        );
    };

    return (
        <>
            {isDemo ? (
                <DemoScreens
                    activeImageSide={activeImageSide}
                    setToothPicker={setToothPicker}
                    setDemo={setDemo}
                    setCamera={setCamera}
                    quickScan={quickScan}
                />
            ) : (
                <div className=''>
                    {errorType.isError &&
                        <PermissionPopup
                            info={errorType}
                            setErrorType={setErrorType}
                        />
                    }

                    {isCamera ? (
                        <>
                            <Camera
                                onTakePhoto={(dataUri) => { handleTakePhoto(dataUri); }}
                                idealFacingMode={facialMode}
                                isFullscreen={false}
                                isMaxResolution={OS === "iOS" ? false : true}
                                imageType={IMAGE_TYPES.JPG}
                                isImageMirror={isMirrored}
                                imageCompression={OS === "iOS" ? 0.5 : 0.6}
                                sizeFactor={1}
                                videoConstraints={{
                                    width: { ideal: window.innerWidth },
                                    height: { ideal: window.innerHeight },
                                    aspectRatio: { ideal: window.innerWidth / window.innerHeight },
                                    facingMode: typeof facialMode === 'object' ? undefined : facialMode
                                }}
                                onCameraStart={cameraStarted}
                                onCameraError={checkError}
                                className="WebCam"
                            />
                            {!errorType.isError && frontCameraError &&
                                <FrontCameraError back={setFrontCameraError} />
                            }
                            {!errorType.isError && backCameraError && storedCameraSide === "back" &&
                                <BackCameraError back={setBackCameraError} />
                            }
                        </>
                    ) : (
                        <>
                            {activeImageSide === -1 ? (
                                <PreviewFace
                                    setImageSide={setImageSide}
                                    image={capturedImage}
                                    setCamera={setCamera}
                                    setToothPicker={setToothPicker}
                                    activeImageSide={activeImageSide}
                                    setDemo={setDemo}
                                    quickScan={quickScan}
                                />
                            ) : (
                                <Preview
                                    setImageSide={setImageSide}
                                    image={capturedImage}
                                    setCamera={setCamera}
                                    setToothPicker={setToothPicker}
                                    activeImageSide={activeImageSide}
                                    setDemo={setDemo}
                                    quickScan={quickScan}
                                />
                            )}
                        </>
                    )}

                    {activeImageSide === -1 ? (
                        isCamera ? <Overlapper /> : null
                    ) : (
                        <>
                            <OvuleShape />
                            <TopLayer />
                        </>
                    )}
                </div>
            )}
        </>
    );
};

export default Shoot;